export const CONTRACT_HUB_DRIVERS_LOAD_REQUEST = 'CONTRACT_HUB_DRIVERS_LOAD_REQUEST';
export const CONTRACT_HUB_DRIVERS_LOAD_SUCCESS = 'CONTRACT_HUB_DRIVERS_LOAD_SUCCESS';
export const CONTRACT_HUB_DRIVERS_LOAD_FAILURE = 'CONTRACT_HUB_DRIVERS_LOAD_FAILURE';
export const CONTRACT_HUB_DRIVERS_ADD = 'CONTRACT_HUB_DRIVERS_ADD';
export const CONTRACT_HUB_DRIVERS_REMOVE = 'CONTRACT_HUB_DRIVERS_REMOVE';
